module.exports = __webpack_public_path__ + "static/media/cat-5.6cc8ee7c.svg";